<template>
  <BasePage>
    <Header slot="header"/>
    <transition mode="out-in" slot="content" name="fade">
      <router-view />
    </transition>
  </BasePage>
</template>

<script>
import Header from './components/Header.vue'
import BasePage from '@/components/layout/BasePage'

export default {
  components: {
    BasePage,
    Header
  }
}
</script>
